import React, { useEffect, useRef } from 'react'

import {
  DropdownGroupHeading,
  DropdownItem,
  DropdownMenuPanel,
} from 'features/trend-detection/components/insight-detail-styles'

export interface DropdownMenuOption {
  key: string
  label: string
}

export interface DropdownMenuSection {
  heading?: string
  options: DropdownMenuOption[]
}

interface DropdownMenuProps {
  sections: DropdownMenuSection[]
  selectedKey?: string
  onSelect: (key: string) => void
  onClose: () => void
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
  sections,
  selectedKey,
  onSelect,
  onClose,
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent): void => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [onClose])

  return (
    <DropdownMenuPanel ref={ref} role="menu">
      {sections.map((section, si) => (
        <React.Fragment key={si}>
          {section.heading && (
            <DropdownGroupHeading>{section.heading}</DropdownGroupHeading>
          )}
          {section.options.map((opt) => (
            <DropdownItem
              key={opt.key}
              $selected={opt.key === selectedKey}
              role="menuitem"
              onClick={() => {
                onSelect(opt.key)
                onClose()
              }}
            >
              {opt.label}
            </DropdownItem>
          ))}
        </React.Fragment>
      ))}
    </DropdownMenuPanel>
  )
}
